import { enumObject, EnumValue } from '@/utils';
import { CommonFilterType } from '..';

export interface SubscriptionDto {
  number: string;
  clientId: string;
  clientName: string;
  communityId: string;
  communityName: string;
  renovationProjectsEnabled: boolean;
  newConstructionProjectsEnabled: boolean;
  pmLiteEnabled: boolean;
  renovationFloorplanEnabled: boolean;
  renovationRoomEnabled: boolean;
  newConstructionFloorplanEnabled: boolean;
  newConstructionRoomEnabled: boolean;
  salesTaxType: SalesTaxType;
}

export type AddSubscriptionDto = Omit<
  SubscriptionDto,
  'id' | 'clientName' | 'communityName' | 'number'
>;

export type UpdateSubscriptionDto = Omit<
  SubscriptionDto,
  'clientName' | 'communityName' | 'clientId' | 'number'
>;

export type SubscriptionDetailsDto = SubscriptionDto;

export interface SubscriptionFilterParams extends CommonFilterType {
  number?: string[];
  clientName?: string[];
  communityName?: string[];
  renovationProjectsEnabled?: boolean;
  newConstructionProjectsEnabled?: boolean;
}

const SALES_TAX_TYPE = ['SummaryLevel', 'ItemLevel'] as const;
export type SalesTaxType = EnumValue<typeof SALES_TAX_TYPE>;
// eslint-disable-next-line
export const SalesTaxType = enumObject('SalesTaxType', SALES_TAX_TYPE);
